// availity-reactstrap-validation
import { AvField, AvForm } from "availity-reactstrap-validation"
import PropTypes from 'prop-types'
import React, { useEffect } from "react"
// Redux
import { connect } from "react-redux"
import { Link, withRouter } from "react-router-dom"
import { Alert, Card, CardBody, Col, Container, Row } from "reactstrap"
import LOGO from "../../assets/images/logo_barra_lateral_blanco.png"
// action
import { userForgetPassword } from "../../store/actions"
import ApiRest from "../../ayudas/apiRest"
import toastr from "toastr"
import _valid from "../../validations"

const ForgetPasswordPage = props => {
    const apiRest = new ApiRest(props);
    useEffect(() => {
        document.body.className = "authentication-bg";
        // remove classname when component will unmount
        return function cleanup() {
            document.body.className = "";
        };
    });

    function handleValidSubmit(event, values) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; 
        if(_valid(values.username)){
            if (emailRegex.test(values.username)) {
                toastr.error("Por favor, introduce tu usuario, no tu correo electrónico.");
            } else if (_valid(values.username)) {
                apiRest.postSinToken('/request-reset-email/', values).then(resultado => {
                    if (resultado.exitoso) {
                        toastr.success('Se ha enviado un email a su correo registrado en el sistema');
                        props.history.push("/login");
                    } else {
                        toastr.error("Hubo un problema al enviar el correo, favor de comunicarse con informática");
                    }
                }).catch(error => {
                    console.error('Error:', error);
                });
            } else {
                toastr.error("Usuario no válido."); 
            }
        } else {
            toastr.error("Usuario es requerido");
        }
    }

    return (
        <React.Fragment>
            <div className="home-btn d-none d-sm-block">
                <Link to="/" className="text-dark">
                    <i className="mdi mdi-home-variant h2"></i>
                </Link>
            </div>

            <div className="account-pages my-5  pt-sm-5">
                <Container>
                    <div className="row justify-content-center">
                        <div className="col-md-8 col-lg-6 col-xl-5">
                            <div>
                                <a href="/" className="mb-5 d-block auth-logo">
                                    <img src={LOGO} alt="" width="100%" className="logo logo-dark" />
                                </a>
                                <Card>
                                    <CardBody className="p-4">
                                        <div className="text-center mt-2">
                                            <h5 className="text-primary">Reiniciar Contraseña</h5>
                                        </div>
                                        <div className="p-2 mt-4">
                                            <div className="alert alert-success text-center mb-4" role="alert">
                                                Ingrese su Usuario
                                            </div>
                                            {props.forgetError && props.forgetError ? (
                                                <Alert color="danger" className="text-center mb-4" style={{ marginTop: "13px" }}>
                                                    {props.forgetError}
                                                </Alert>
                                            ) : null}
                                            {props.forgetSuccessMsg ? (
                                                <Alert color="success" className="text-center mb-4" style={{ marginTop: "13px" }}>
                                                    {props.forgetSuccessMsg}
                                                </Alert>
                                            ) : null}

                                            <AvForm
                                                className="form-horizontal"
                                                onValidSubmit={(e, v) => handleValidSubmit(e, v)}
                                            >
                                                <div className="mb-3">
                                                    <AvField
                                                        name="username"
                                                        label="Usuario"
                                                        className="form-control"
                                                        placeholder="Ingrese su usuario"
                                                        type="text"
                                                        required
                                                    />
                                                    {/*<AvField
                                                        name="email"
                                                        label="Correo Electrónico"
                                                        className="form-control"
                                                        placeholder="Ingresar correo electrónico"
                                                        type="text"
                                                        required
                                                    />*/}
                                                </div>
                                                <Row className="row mb-0">
                                                    <Col className="col-12 text-end">
                                                        <button
                                                            className="btn btn-primary w-md waves-effect waves-light"
                                                            type="submit"
                                                        >
                                                            Reiniciar
                                                        </button>
                                                    </Col>
                                                </Row>
                                                <div className="mt-4 text-center">
                                                    <p className="mb-0"> <Link to="/login" className="fw-medium text-primary"> Ingresar </Link></p>
                                                </div>
                                            </AvForm>
                                        </div>
                                    </CardBody>
                                </Card>
                            </div>
                        </div>
                    </div>
                </Container>
            </div>
        </React.Fragment>
    )
}

ForgetPasswordPage.propTypes = {
    forgetError: PropTypes.any,
    forgetSuccessMsg: PropTypes.any,
    history: PropTypes.object,
    userForgetPassword: PropTypes.func
}

const mapStatetoProps = state => {
    const { forgetError, forgetSuccessMsg } = state.ForgetPassword
    return { forgetError, forgetSuccessMsg }
}

export default withRouter(
    connect(mapStatetoProps, { userForgetPassword })(ForgetPasswordPage)
)
